<template>
  <v-dialog
    width="500px"
    persistent
    :value="value"
  >
    <v-card>
      <v-card-title class="errorHeader font-weight-bold">
        {{ $t('dialogs.error.title') }}
      </v-card-title>

      <v-card-text class="mt-1 pb-3 pt-2">
        {{ message }}
      </v-card-text>

      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn dark color="error" @click="dismissDialog()">{{ $t('actions.ok') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    message: String,
  },

  methods: {
    dismissDialog() {
      this.$emit('dismiss-dialog');
    },
  },
};
</script>

<style scoped>
.errorHeader {
  color: white;
  background-color: var(--v-error-base);
}
</style>
